import { Platform, StyleSheet } from 'react-native';

import { colors, spacing } from '../../theme';

export const styles = StyleSheet.create({
	root: {
		maxWidth: '100%',
	},
	// @ts-expect-error - valid on web
	textStyle: Platform.select({
		web: {
			width: `calc(100% - ${spacing(2)}px)`,
			maxWidth: '100%',
		},
		default: {},
	}),
	gutter: {
		marginVertical: spacing(),
	},
	fullWidth: {
		width: '100%',
	},
	label: {
		marginBottom: spacing(),
	},
	basic: { borderColor: colors.black400 },
	danger: { borderColor: colors.danger800 },
});
